import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref, watch } from "vue";
import ModalError from "../Commons/ModalError.vue";
import ModalSorteoSuccess from "./ModalSorteoSuccess.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ModalSorteo',
  props: {
    isVisible: { type: Boolean },
    participantes: {}
  },
  emits: ["close", "confirm"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const internalIsVisible = ref(props.isVisible);
const showErrorModal = ref<boolean>(false);
const showSuccessModal = ref<boolean>(false);
const ganador = ref<string>();

watch(
  () => props.isVisible,
  (newValue) => {
    internalIsVisible.value = newValue;
  }
);

const isGenerating = ref<boolean>(false);

const closeModal = () => {
  internalIsVisible.value = false;
  emit("close");
};

const sortear = async () => {
  try {
    isGenerating.value = true;
    const participantes = props.participantes;
    if (participantes === undefined)
      throw new Error("No hay participantes para el sorteo.");
    if (participantes.length === 0)
      throw new Error("No hay participantes para el sorteo.");

    const randomIndex = Math.floor(Math.random() * participantes.length);
    ganador.value = participantes[randomIndex];

    showSuccessModal.value = true;
  } catch (error) {
    console.error(error);
    showErrorModal.value = true;
  } finally {
    isGenerating.value = false;
    closeModal();
  }
};

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_dialog, {
      modelValue: internalIsVisible.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((internalIsVisible).value = $event)),
      "max-width": "600px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, null, {
              default: _withCtx(() => [
                _createTextVNode("Realizar sorteo")
              ]),
              _: 1
            }),
            _createVNode(_component_v_divider),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_form, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, {
                      justify: "center",
                      class: "my-4 ga-5"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                          variant: "tonal",
                          color: "primary",
                          onClick: sortear,
                          large: ""
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Sortear")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_btn, {
                          variant: "tonal",
                          color: "secondary",
                          onClick: closeModal,
                          large: ""
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Cancelar")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: isGenerating.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((isGenerating).value = $event)),
      "hide-overlay": "",
      persistent: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { class: "progress-card" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_progress_circular, {
              indeterminate: "",
              color: "primary",
              size: "70"
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(ModalSorteoSuccess, {
      isVisible: showSuccessModal.value,
      message: ganador.value,
      "onUpdate:isVisible": _cache[2] || (_cache[2] = ($event: any) => (showSuccessModal.value = $event))
    }, null, 8, ["isVisible", "message"]),
    _createVNode(ModalError, {
      isVisible: showErrorModal.value,
      message: "No se ha podido realizar el sorteo. Si el error persiste contacta con el administrador.",
      "onUpdate:isVisible": _cache[3] || (_cache[3] = ($event: any) => (showErrorModal.value = $event))
    }, null, 8, ["isVisible"])
  ], 64))
}
}

})